'use client'
import { useCommonStore } from '@/store/common'
import { useEffect } from 'react'
import { ToastContainer, TypeOptions, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
interface ToastProviderProps {
  children: React.ReactNode
}
interface IPromiseToast {
  content: string
  status: boolean
  callback: (() => Promise<any>) | undefined
  messageLoading?: string
  messageError?: string
}
export default function ToastProvider({ children }: ToastProviderProps) {
  const { notifications } = useCommonStore()
  //   const contextClass = {
  //     success: '',
  //     error: 'bg-red-600',
  //     info: 'bg-gray-600',
  //     warning: 'bg-orange-400',
  //     default: 'bg-indigo-600',
  //     dark: 'bg-white-600 font-gray-300',
  //   }
  const handleCreateNoti = async (
    content: string,
    type: TypeOptions | undefined,
    isPromise?: IPromiseToast
  ) => {
    if (isPromise?.status == true) {
      const idToast = toast.loading(isPromise?.messageLoading)
      if (isPromise?.callback) {
        await isPromise
          ?.callback()
          .then((res) => {
            if (res?.status == 'error' || !res?.data) {
              return toast.update(idToast, {
                render: isPromise?.messageError ?? res?.message,
                type: 'error',
                isLoading: false,
                autoClose: 3 * 1000,
                closeButton: true,
              })
            }
            toast.update(idToast, {
              render: isPromise?.content ?? res?.message,
              type: type ?? 'success',
              isLoading: false,
              autoClose: 3 * 1000,
              closeButton: true,
            })
          })
          .catch((error) => {
            toast.update(idToast, {
              render: JSON.stringify(error),
              type: 'error',
              isLoading: false,
              autoClose: 3 * 1000,
              closeButton: true,
            })
          })
        return
      } else {
        console.error('isPromise.callback is not a function')
        return
      }
    }
    toast(content, { type })
  }

  useEffect(() => {
    if (notifications?.content)
      handleCreateNoti(notifications?.content, notifications?.type ?? 'success', notifications?.isPromise)
  }, [notifications])
  return (
    <>
      {children}
      <ToastContainer
        autoClose={3000}
        position="top-right"
        closeOnClick
        closeButton={true}
        bodyClassName={() => 'text-sm font-white font-med block p-3 flex items-center'}
        // toastClassName={(context) =>
        //   contextClass[context?.type || 'default'] +
        //   ' relative flex p-1 min-h-10 rounded-md justify-between overflow-hidden cursor-pointer text-black'
        // }
      />
    </>
  )
}
